<script>
  import Item from "./Item.svelte";
  import l from "../scripts/utilities.js";
  /**
   * @typedef {Object} Props
   * @property {any} [items]
   * @property {string} [title]
   * @property {any} [categories]
   * @property {string} [cl]
   */

  /** @type {Props} */
  let {
    items = [],
    title = '',
    categories = [],
    cl = ''
  } = $props();
  let searchterm = $state('');
  let select = $state();

  //items = updateItems(items, categories);

  function updateItems(i,c) {
    let latest = c.find(o=>{
      return o.id === 1141;
    });
    console.log("latest")
    console.log(latest)
    let out =  i;
    if (out.length) {
      out[0].categories.push(latest[0]);
    }
    console.log(out);
    return out;
  }
  function onkeyup(e) {
		filtered = items.filter(function(s) {
			return s.searchable.indexOf(searchterm.toLowerCase()) > -1;
		});
	}


	function onkeydown(e) {
		if (e.key === "Enter" || e.keyCode === 13) {
			e.preventDefault();
		}
	}

  function filterOnChange() {
    let out = items;
    console.log(select);
    if (select.id == "1176") {
      console.log("alle")
      out = items;
      // console.log(filtered)
    } else {
      out = items.filter((r) => {
        let cats = r.categories;
        let f = cats.filter(c => {
          return select.id == c.id;
        });
        if (f.length) return r;
      });
    }

    return out;
  }
  let filtered = $derived(typeof select === "undefined" ? items : filterOnChange());
  let showsearch = $derived(typeof select === "undefined" || select.id == "1141" ? false : true);
  </script>



<div class="background {cl}">
  <h3 class="category-title h-bold"><span class="h-underline">{title}</span></h3>
  {#if items.length}
  <div class="form-group select-list">
    <label for="filter-categories">{l("show")}</label>
    <select id="filter-categories" bind:value={select}>
      <!-- <option value="">--</option> -->
      {#each categories as category,i}
      <option value={category}>{category.title}</option>
      {/each}
    </select>

  </div>


  {#if showsearch}
  <div class="form-group">
    <label for="search-{cl}" class="sr-only">Suche</label>
    <input type="text" id="search-{cl}" name="search-{cl}" bind:value={searchterm}  {onkeyup} {onkeydown} />
  </div>
  {/if}
<div class="listing">
  <ul>
    {#each filtered as item}
      <Item item={item} />
    {/each}
  </ul>
</div>
{/if}
</div>
